import React, {useMemo, type FC} from 'react';
import {IProduct} from '../../../../types/galleryTypes';
import {useGlobals, withGlobals} from '../../../../globalPropsContext';
import {ProductQuickAddMobile} from './ProductQuickAddMobile/ProductQuickAddMobile';
import {ProductQuickAddDesktop} from './ProductQuickAddDesktop/ProductQuickAddDesktop';
import {useProductQuickAddOptions} from './ProductQuickAddContent/hooks/useProductQuickAddOptions';

export interface IProductQuickAddProps {
  product: IProduct;
  productIndex: number;
  productItemRef: React.RefObject<HTMLDivElement>;
  quantity: number;
}

const ProductQuickAddComp: FC<IProductQuickAddProps> = ({
  product: _product,
  productIndex,
  productItemRef,
  quantity,
}) => {
  const {shouldShowMobile} = useGlobals();
  const productQuickAddOptions = useProductQuickAddOptions(_product.options);

  const product = useMemo(() => {
    return {..._product, options: productQuickAddOptions};
  }, [_product, productQuickAddOptions]);

  if (productQuickAddOptions.length === 0) {
    return null;
  }

  return shouldShowMobile ? (
    <ProductQuickAddMobile product={product} quantity={quantity} productIndex={productIndex} />
  ) : (
    <ProductQuickAddDesktop
      product={product}
      quantity={quantity}
      productIndex={productIndex}
      productItemRef={productItemRef}
    />
  );
};

export const ProductQuickAdd = withGlobals(ProductQuickAddComp);
